export const ROUTE_PATH = '/reconciliations-merchants';

export const FEATURE_NAME = 'merchantsReconciliationPage';

export const POST_URL = '/merchant-reconciliation/';

export const REPAY_CONFIRMATION_MSG =
  'Вы уверены, что хотите завершить данную реконсиляцию?';
